export default [
  {
    path: '/cicadas',
    title: 'Cicadas',
    date: '2015-01-06',
    interests: 'math, contrived population genetics',
  },
  {
    path: '/traffic',
    title: 'Traffic',
    date: '2015-01-10',
    interests: 'traffic (skim for the results), PDEs',
  },
  {
    path: '/bollards',
    title: 'Bollards',
    date: '2015-01-25',
    interests: 'physics, tinkering, ODEs',
  },
  {
    path: '/lda',
    title: 'Latent Dirichlet Allocation',
    date: '2015-03-03',
    interests: 'unsupervised learning, natural language processing',
  },
  {
    path: '/interpolation',
    title: 'Interpolation on a Sphere',
    date: '2015-03-22',
    interests: 'math, geometry',
  },
  {
    path: '/tournament',
    title: 'A Tournament',
    date: '2015-04-24',
    interests: 'math, graph theory',
  },
  {
    path: '/hvz',
    title: 'Humans versus Zombies',
    date: '2015-10-09',
    interests: 'game theory, cool plots',
  },
  {
    path: '/reviews',
    title: 'Review Doping',
    date: '2015-12-05',
    interests: 'online reviews (skim for the results), statistics',
  },
  {
    path: '/chopsticks',
    title: 'Chopsticks',
    date: '2016-01-18',
    interests: 'game theory, interactive visualizations',
  },
  {
    path: '/stocks',
    title: 'What Grounds Stock Prices?',
    date: '2016-02-23',
    interests: 'economics',
  },
  {
    path: '/sieves',
    title: 'Prime Sieves',
    date: '2016-08-20',
    interests: 'number theory, computational complexity',
  },
  {
    path: '/reinforcement',
    title: 'Reinforcement Learning',
    date: '2017-03-13',
    interests: 'toy machine learning problems',
  },
  {
    path: '/presidents',
    title: 'President Rankings',
    date: '2017-05-11',
    interests: 'US history, unsupervised learning, interactive visualizations',
  },
  {
    path: '/crosswalks',
    title: 'Crosswalks',
    date: '2017-11-13',
    interests: 'walking in cities',
  },
  {
    path: '/startups',
    title: 'Startup Names',
    date: '2017-12-31',
    interests: 'laughing about startups',
  },
  {
    path: '/magic',
    title: 'Magic: The Gathering',
    date: '2018-02-18',
    interests: 'competitions, unsupervised learning, Bayesian statistics',
  },
  {
    path: '/betting',
    title: 'Betting',
    date: '2018-09-09',
    interests: 'game theory, interactive visualizations',
  },
  {
    path: '/height',
    title: 'Height and Natural Talent',
    date: '2019-02-17',
    interests: 'rock climbing, basketball, statistics, interactive visualizations',
  },
  {
    path: '/numeri',
    title: 'numeri',
    date: '2019-10-27',
    interests: 'numerical libraries',
  },
  {
    path: '/fruits',
    title: 'Fruits',
    date: '2020-07-24',
    interests: 'evolutionary history',
  },
  {
    path: '/who',
    title: 'World Health Organization Game',
    date: '2020-?',
    hide: true,
    interests: 'simulations, sandboxes',
  },
  {
    path: '/rogue-earth',
    title: 'Rogue Earth',
    date: '2020-08-25',
    interests: 'little webgames',
  },
  {
    path: '/quantile-compression',
    title: 'Quantile Compression',
    date: '2021-06-21',
    interests: 'compression, statistics',
  },
  {
    path: '/wordle',
    title: 'Wordle',
    date: '2022-01-23',
    interests: 'wordle, hackery',
  },
  {
    path: '/rivers',
    title: 'Rivers',
    date: '2022-04-14',
    interests: 'hydrology, ODEs',
  },
  {
    path: '/reducing-parquet',
    title: 'Reducing Parquet Size 71% with Quantile Compression',
    date: '2022-07-17',
    interests: 'compression, data engineering',
  },
  {
    path: '/entropy',
    title: 'Measuring Entropy',
    date: '2023-02-02',
    interests: 'statistics',
  },
  {
    path: '/matrix-decompositions',
    title: '6 Matrix Decompositions Everyone* Should Know',
    date: '2023-03-27',
    interests: 'linear algebra',
  },
  {
    path: '/streaming-ans-explained',
    title: 'Streaming Asymmetric Numeral System Explained',
    date: '2023-09-10',
    interests: 'compression (explained for beginners)',
  },
  {
    path: '/map-projections-1',
    title: 'Map Projections 1: Not Solving Exactly',
    date: '2023-09-28',
    interests: 'differential geometry, PDEs',
  },
  {
    path: '/pcodec',
    title: 'pcodec',
    date: '2023-12-31',
    interests: 'compression, data engineering',
  },
  {
    path: '/the-parquet-we-could-have',
    title: 'The Parquet We Could Have',
    date: '2024-01-02',
    interests: 'compression, data engineering (explained for beginners)',
  },
  {
    path: '/map-projections-2',
    title: 'Map Projections 2: Solving Numerically',
    date: '2024-02-21',
    interests: 'maps, linear algebra, machine learning',
  },
  {
    path: '/map-projections-3',
    title: 'Map Projections 3: The Essential Results',
    date: '2024-03-06',
    interests: 'maps',
  },
  {
    path: '/map-projections-4',
    title: 'Map Projections 4: Bullying the Ocean',
    date: '2024-03-18',
    interests: 'maps',
  },
  {
    path: '/map-projections-5',
    title: 'Map Projections 5: More Interruptions',
    date: '2024-04-13',
    interests: 'maps',
  },
  {
    path: '/better-buf-read',
    title: 'BetterBufRead: Faster Reads in Rust',
    date: '2024-11-13',
    interests: 'fast code, Rust',
  },
  {
    path: '/dtype-dispatch',
    title: 'dtype_dispatch: a beautiful hack',
    date: '2024-11-15',
    interests: 'programming, Rust',
  },
];



// WEBPACK FOOTER //
// src/core/postsByIndex.js